module.exports = __webpack_public_path__ + "static/media/omahngayomi.dbc1cabb.jpg";